/* PIOSA Nail Color Studio — photographic nail recolouring (stationary hand).
   The approved photo is drawn untouched; only nail pixels are recomputed:
   colour = shade × (photo shading) + (photo specular), edges un-mixed against the original pixel.
   Data map (PNG): R = sqrt(luminance), G = nail coverage, B = nail id (1..5 in animation order). */
(function () {
  const lin = c => { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
  const enc = v => { v = v <= 0 ? 0 : v >= 1 ? 1 : v; return 255 * (v <= 0.0031308 ? v * 12.92 : 1.055 * Math.pow(v, 1 / 2.4) - 0.055); };
  const hexLin = h => [1, 3, 5].map(i => lin(parseInt(h.slice(i, i + 2), 16)));
  const LUT = new Float32Array(256); for (let i = 0; i < 256; i++) LUT[i] = lin(i);
  const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  const load = src => new Promise((ok, no) => { const i = new Image(); i.decoding = 'async'; i.onload = () => ok(i); i.onerror = no; i.src = src; });

  async function mount(root) {
    const canvas = root.querySelector('[data-nail-canvas]');
    const meta = JSON.parse(root.querySelector('[data-nail-meta]').textContent);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mapBlob = fetch(root.dataset.map).then(r => r.blob())
      .then(b => createImageBitmap(b, { colorSpaceConversion: 'none', premultiplyAlpha: 'none' }));   // exact data values
    const [photo, map] = await Promise.all([load(root.dataset.photo), mapBlob]);
    const W = photo.naturalWidth, H = photo.naturalHeight;
    canvas.width = W; canvas.height = H;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(photo, 0, 0);
    const base = ctx.getImageData(0, 0, W, H).data;              // untouched photo pixels
    const mc = document.createElement('canvas'); mc.width = W; mc.height = H;   // map is a data image, never colour-managed
    const mctx = mc.getContext('2d', { willReadFrequently: true }); mctx.drawImage(map, 0, 0);
    const md = mctx.getImageData(0, 0, W, H).data;

    // per-nail pixel lists
    const nails = meta.map((m, k) => {
      const [x0, y0, x1, y1] = m.box, w = x1 - x0, h = y1 - y0, idx = [];
      for (let y = y0; y < y1; y++) for (let x = x0; x < x1; x++) { const p = (y * W + x) * 4; if (md[p + 2] === k + 1 && md[p + 1] > 0) idx.push(p); }
      return { ...m, x0, y0, w, h, idx, img: ctx.getImageData(x0, y0, w, h), cur: null, from: null, to: null };
    });

    function paint(n, col) {                                        // col = linear RGB of the shade
      const out = n.img.data, yb = n.yb, g = n.g;
      for (const p of n.idx) {
        const a = md[p + 1] / 255, y = (md[p] / 255) ** 2;
        const d = Math.min(y, yb) / yb, s = Math.max(y - yb, 0) * 1.15;
        const x = (p / 4) % W - n.x0, yy = ((p / 4 / W) | 0) - n.y0, q = (yy * n.w + x) * 4;
        for (let c = 0; c < 3; c++) {
          const o = LUT[base[p + c]];
          const v = a >= 0.97 ? col[c] * d + s : o * (1 - a) + col[c] * d * a;   // edges: blend shaded polish over the original pixel
          out[q + c] = enc(v);
        }
      }
      ctx.putImageData(n.img, n.x0, n.y0);
    }

    let raf = 0, t0 = 0;
    const DUR = 460, STAGGER = 150;
    function setColor(hex, instant) {
      const target = hexLin(hex);
      nails.forEach(n => { n.from = n.cur ? n.cur.slice() : n.g.slice(); n.to = target; });
      if (instant || reduce || document.hidden) { nails.forEach(n => { n.cur = target.slice(); paint(n, n.cur); }); return; }
      t0 = performance.now(); if (!raf) raf = requestAnimationFrame(tick);
    }
    function tick(now) {
      raf = 0; const busy = frame(now - t0);
      if (busy) raf = requestAnimationFrame(tick);
    }
    function frame(e) {
      let busy = false;
      nails.forEach((n, i) => {
        const t = Math.min(1, Math.max(0, (e - i * STAGGER) / DUR));
        if (t > 0 && (!n.cur || t <= 1)) {
          const k = ease(t); n.cur = n.from.map((v, c) => v + (n.to[c] - v) * k); paint(n, n.cur);
        }
        if (t < 1) busy = true;
      });
      return busy;
    }
    // QA helper: render the sequence at a fixed time (ms) without rAF
    function seek(hex, ms) { const target = hexLin(hex); nails.forEach(n => { if (!n._s) { n.from = n.cur ? n.cur.slice() : n.g.slice(); n._s = 1; } n.to = target; }); frame(ms); if (ms >= DUR + STAGGER * 4) nails.forEach(n => delete n._s); }
    root.classList.add('is-ready');
    const api = { setColor, seek, nails }; root.__nails = api; return api;
  }
  window.PIOSA_NAILS = { mount };
})();
